// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3JtZ-","cell":"ColumnAccessor_cell__39Iph","firstCellAccent":"ColumnAccessor_firstCellAccent__1WMee"};